import React, { forwardRef } from 'react';

import InputTemplate from '../TemplateNumberFormatInput';

const VolumeInput = forwardRef((props, ref) => (
  <InputTemplate {...props} escala={3} sufixo=" m3" ref={ref} />
));

export default VolumeInput;
